import React from 'react';
import PropTypes from 'prop-types';

import NormalJsonPlaceSearchFormField from '../../normal/JsonPlaceSearchFormField';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onSelect: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onGettingCoord: PropTypes.func,
  onClearCoord: PropTypes.func,
  onFieldChange: PropTypes.func,
  onFieldBlur: PropTypes.func,
  enableEditing: PropTypes.any,
  additionalRestrictions: PropTypes.shape(),
  filterType: PropTypes.string,
  onAddress: PropTypes.func,
};

const defaultProps = {
  onGettingCoord: () => {},
  onClearCoord: () => {},
  onFieldChange: () => {},
  onFieldBlur: () => {},
};

export const JsonPlaceSearchFormField = props => {
  const {
    label,
    id,
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    onGettingCoord,
    onClearCoord,
    onFieldChange,
    onFieldBlur,
    initialValue,
    enableEditing,
    additionalRestrictions,
    filterType,
    onAddress,
  } = props;

  const handleChange = newValue => {
    onChange(newValue);
    onFieldChange(newValue);
  };

  const handleBlur = () => {
    onBlur();
    onFieldBlur();
  };

  return (
    <NormalJsonPlaceSearchFormField
      value={value}
      onChange={handleChange}
      onAddress={onAddress}
      onBlur={handleBlur}
      onFocus={onFocus}
      id={id}
      label={label}
      touched={touched}
      invalid={invalid}
      errMsg={error}
      onGettingCoord={onGettingCoord}
      onClearCoord={onClearCoord}
      initialValue={initialValue}
      disabled={enableEditing}
      additionalRestrictions={additionalRestrictions}
      filterType={filterType}
    />
  );
};

JsonPlaceSearchFormField.propTypes = propTypes;
JsonPlaceSearchFormField.defaultProps = defaultProps;

export default JsonPlaceSearchFormField;
